(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["media-lp-blocks"]) return;
  try {
    
	document.querySelectorAll('.g3Media__Item').forEach(function (ele, index) {
		ele.addEventListener('mouseover', function(){
			gsap.to(this.querySelector('img'), {scale: 1.05, duration: 1.5, ease: "power2.out"});
		});
		ele.addEventListener('mouseleave', function(){
			gsap.to(this.querySelector('img'), {scale: 1, duration: 1.5, ease: "power2.out"});
		});
	});


  } catch(e) { console.error(e); }
})();

})();
